export default "__VITE_ASSET__DD31bYYi__"